



























import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        InputNumber: InputNumber,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.certificates.globalThermalInsulationLevel",
            inputName: "global-thermal-insulation-level",
            specificId: uuidv4() as string
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "HOMES_TO_BUILD", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        globalThermalInsulationLevel: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(globalThermalInsulationLevel: number): void {
            if (globalThermalInsulationLevel == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": globalThermalInsulationLevel});
            }
        },
    },
});
